import styled from 'styled-components';

export const SubscriptionCardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.black2};
  }
`;

export const CourseInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

export const CourseName = styled.span`
  width: 100%;
  max-width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  @media (max-width: ${({ theme }) => theme.mediaQueries.md}) {
    max-width: 100%;
    white-space: normal;
  }
`;

export const CourseProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const ProgressBarWrapper = styled.div`
  width: 130px;
`;
export const EmojiWrapper = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  aspect-ratio: 1/1;
  font-size: 30px;
  font-weight: 600;
  line-height: 30px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 48px;
    height: 48px;
    padding: 12px 16px;
    gap: 10px;
    font-size: 38px;
    line-height: 46px;
  }
`;

export const ProgressText = styled.span<{ $isProgressStarted: boolean }>`
  color: ${({ theme, $isProgressStarted }) =>
    $isProgressStarted ? theme.colors.green7 : theme.colors.black7};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
